import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

export const MenuDrawerBackdropStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "menu-drawer-backdrop",
})`
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  z-index: ${ScreenDepth.MENU_DRAWER_BACKDROP};
  width: 100vw;
  height: 100dvh;
  overflow: hidden;
  outline: 0;
  transition: opacity 0.55s ease-out;
  background-color: rgba(59, 59, 59, 0.4);
`;
